module.exports = ".modal-content {\n  padding: 20px; }\n\n.modal-content p {\n  font-size: 1.5em;\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/ticket-ayuda-modal/ticket-ayuda-modal.component.scss
// module id = ./src/app/components/partials/ticket-ayuda-modal/ticket-ayuda-modal.component.scss
// module chunks = main